import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import PropTypes from "prop-types";
import DataTable from "../../Shared/DataTable";
import { MdModeEdit, MdDelete } from "react-icons/md";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";
export class InterestsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.adminInterestTable.target,
          content: (
            <div>
              <p>{tourMessages.adminInterestTable.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "10px" }}
              >
                {tourMessages.adminInterestTable.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP" , close: 'Next'},
        },
        tourMessages.default,
      ],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.showJoyRideOnTable) {
      this.setState({ run: true });
      this.props.stopJoyRideAtDataTable();
    }
  }
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };
  render() {
    const columns = [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Category",
        accessor: "categoryName",
      },
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      deleteInterest,
      showModal,
      pages,
      page,
      pageSize,
      setPageNumber,
      setPageSize,
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "edit",
        btnText: "Edit",
        btnAction: selectRow,
        btnClass: "btn-primary",
        btnIcon: MdModeEdit,
      },
      {
        name: "delete",
        btnText: "Delete",
        btnAction: showModal,
        btnClass: "btn-danger",
        btnIcon: MdDelete,
      },
    ];

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Card className="joyride7">
          <CardHeader>Interests</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteInterest}
              selectRow={selectRow}
              showModal={showModal}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="name"
              searchPlaceholder="Search by name"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

InterestsTable.propTypes = {
  data: PropTypes.object,
  loadData: PropTypes.func,
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  error: PropTypes.object,
};

export default InterestsTable;
